@if (labelCols != null) {
    <div [ngClass]="{'form-group row': labelCols > 0}">
        @if (labelCols > 0) {
            <label class="col-form-label" [class]="labelClass" [for]="id">{{ label }}</label>
        }
        <div [class]="inputColsClass">
            <ng-container [ngTemplateOutlet]="textInput" />
        </div>
    </div>
} @else {
    <div [ngClass]="{'mb-3': label.length > 0}">
        @if (label.length > 0) {
            <div class="d-flex justify-content-between">
                <label class="form-label" [class]="labelClass" [for]="id">{{ label }}</label>
                @if (information) {
                    <app-popover-icon class="ms-3" [popover]="information" />
                }
            </div>
        }
        <ng-container [ngTemplateOutlet]="textInput" />
    </div>
}

<ng-template #textInput>
    <input
        [type]="type()"
        class="form-control"
        [formControl]="formControl"
        [id]="id"
        [name]="name"
        [maxlength]="maxLength"
        (blur)="onBlur()"
        [autocomplete]="autoCompleteResolved"
        [class.is-invalid]="ngControl.invalid && ngControl.touched"
        [placeholder]="this.placeholder"
        #input />
    @if (ngControl.control != null) {
        <app-control-messages [control]="ngControl.control"></app-control-messages>
    }
</ng-template>
